import React, { ReactNode, useEffect, useReducer } from 'react';
import { TextEntry } from './TextEntry';
import { Icons } from '../../Icons/Icons';
import { Card } from '../../Layout/Card';
import { SimpleTextViewModel } from '../../../../../ViewModel';
import { ItemsManager } from '../../../../../ViewModel/Services/ItemsManager';
import { GetCorrelation } from '../../../../../ViewModel/Utilities';
import { GLStep } from '../../../../../ViewModel/TutorialStateViewModel';
import { TutorialFlyout } from '../../TutorialFlyout';


interface TextEntryListProps {
    title: string;
    entries: ItemsManager<SimpleTextViewModel>;
    headerIcon?: ReactNode;
    onChanged?: () => void;
    onLosingFocus?: () => void;
    className?: string;
    headerClassName?: string;
    tutorialSteps?: GLStep[]
}


export const TextEntryList: React.FC<TextEntryListProps> = ({ entries, title, headerIcon, onChanged, className, headerClassName, tutorialSteps }) => {

    const [allEntries, setAllEntries] = React.useState<SimpleTextViewModel[]>([]);
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [focusedIndex, setFocusedIndex] = React.useState<number | undefined>(undefined);

    //
    // This is the useEffect that will run when the component is mounted
    //
    useEffect(() => {

        const entryChanged = () => {
            forceUpdate();
        }

        const entriesChanged = async () => {

            if (entries.values.length === 0) {
                await entries.CreateItem(GetCorrelation());
            }

            for (let entry of entries.values) {
                entry.PropertyChanged.Subscribe(entryChanged);
            }

            setAllEntries(entries.values);
            // setFocusedIndex(entries.values.length - 1);
        }


        entries.PropertyChanged.Subscribe(entriesChanged);
        entriesChanged();

        return () => {
            entries.PropertyChanged.Unsubscribe(entriesChanged);
        }
    }, [entries]);


    const header = headerIcon ? headerIcon : <Icons.CardBulletIcon />;

    const addItem = async (updateFocus = true) => {
        await entries.CreateItem(GetCorrelation());
        if (updateFocus)
            setFocusedIndex(entries.values.length - 1);
    }


    return (
        <div className={'gl-list ' + (className ?? '')} >
            <Card noMargin disableClick>
                <TutorialFlyout steps={tutorialSteps}>
                    <div className={`flex flex-row justify-content-start align-items-center mb-3 ${headerClassName}`}>
                        {header}
                        <p className='gl-list-header-spacing gl-content-header-typography'>{title}</p>
                    </div>
                </TutorialFlyout>
                {
                    allEntries.map((entry, index) => (
                        <TextEntry key={entry.TypedData?.key} simpleText={entry}
                            onDelete={() => {
                                entries.DeleteItem(GetCorrelation(), entry);
                                onChanged && onChanged();
                            }}
                            onAdd={() => {
                                addItem(true);
                                onChanged && onChanged();
                            }}
                            onChanged={onChanged}
                            onEnterPressed={() => {
                                if (index === allEntries.length - 1) {
                                    if (entry.TypedData?.text !== '')
                                        addItem();
                                }
                                else
                                    setFocusedIndex(index + 1);
                            }}
                            onLosingFocus={() => {
                                if (index < allEntries.length - 1)
                                    setFocusedIndex(index + 1);
                            }}
                            allowEmptyDelete={index > 0}
                            shouldCaptureFocus={index === focusedIndex}
                        />
                    ))
                }
            </Card>
        </div>
    );
};